'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConfirmRegistrationRequest = require('./lib/ConfirmRegistrationRequest');

var _ConfirmRegistrationRequest2 = _interopRequireDefault(_ConfirmRegistrationRequest);

var _ShopParameters = require('./lib/ShopParameters');

var _ShopParameters2 = _interopRequireDefault(_ShopParameters);

var _ShopSettingsResponse = require('./lib/ShopSettingsResponse');

var _ShopSettingsResponse2 = _interopRequireDefault(_ShopSettingsResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var map = {
    ConfirmRegistrationRequest: _ConfirmRegistrationRequest2.default,
    ShopParameters: _ShopParameters2.default,
    ShopSettingsResponse: _ShopSettingsResponse2.default
};

exports.default = map;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/Models/register.js
// module id = 1589
// module chunks = 0